import { DeliveryAddress } from './DeliveryAddress'
import { withDeliveryAddress } from './withDeliveryAddress'

const ConnectedDeliveryAddress = withDeliveryAddress(DeliveryAddress)
export { ConnectedDeliveryAddress as DeliveryAddress }
